exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tab-history[data-v-6b383616]{display:block}", ""]);

// exports
